module.exports = __webpack_public_path__ + "images/report.d04fb9f0848aae111ebadd6a0bc13e69.png";